import type { TravelDocsInfo } from '@eti/schema-types';

type TripInformationDocumentType = {
  dataTestId: string;
  title?: string | null;
  description?: string | null;
};

export const getTripInformationDocuments = (
  travelDocsInfo: TravelDocsInfo | null | undefined,
): TripInformationDocumentType[] => {
  let documents: TripInformationDocumentType[] = [];

  if (travelDocsInfo) {
    const { apisInfo, visaInfo } = travelDocsInfo;

    documents = visaInfo.map((document) => ({
      title: document.title,
      description: document.description,
      dataTestId: `document-${document.country.code.toLowerCase()}-expansion-panel`,
    }));

    if (apisInfo) {
      documents.push({
        title: apisInfo.title,
        description: apisInfo.description,
        dataTestId: `document-apis-expansion-panel`,
      });
    }
  }

  return documents;
};
